import React from 'react'

const ArrowRightIcon = (props) => (
  <svg
    viewBox='0 0 20 15'
    {...props}
  >
    <path
      fill='currentColor'
      d='M13.264 14.764l-1.204-1.232 4.368-4.396.896-.616-.084-.308-1.092.14H.16V6.588h15.988l1.092.112.084-.28-.896-.644-4.368-4.368L13.264.176l6.664 6.664V8.1l-6.664 6.664z'
    />
  </svg>
)

export default ArrowRightIcon
